import * as Sentry from '@sentry/browser'
const bcrypt = require('bcryptjs')
const md5 = require('md5')
export const state = () => ({
  auth: {
    isAuth: null,
    email: null,
    token: null,
    expiration: null,
    userData: null,
    role: null,
    role_endpoint: null,
    showFlag: true,
    totalConnectedFacility: 0
  },
  connectedFacilities: null,
  uploadPercentage: 0,
  pinToken: ''
})

export const getters = {
  getAuthUserData: (state) => {
    return state.auth.userData
  }
}

export const mutations = {
  SET_PROGRESS: (state, data) => {
    state.uploadPercentage = data
  },
  SET_USER_EMAIL: (state, email, self) => {
    state.auth.email = email
  },
  SET_USER_TOKEN: (state, token, self) => {
    state.auth.token = token
  },
  SET_USER_EXPIRATION: (state, expiration, self) => {
    state.auth.expiration = expiration
  },
  SET_USER_DATA: (state, data) => {
    state.auth.userData = data
  },
  SET_USER_IS_LOGGED: (state, data) => {
    state.auth.isAuth = data
  },
  SET_USER_ROLE: (state, data) => {
    state.auth.role = data
  },
  SET_USER_ROLE_ENDPOINT: (state, data) => {
    state.auth.role_endpoint = data
  },
  SET_USER_ROLE_FLAG_ENDPOINT: (state, data) => {
    state.auth.showFlag = data
  },
  SET_TOTAL_CONNECTED_FACILITY: (state, data) => {
    state.auth.totalConnectedFacility = data
  },
  SET_CONNECTED_FACILITY: (state, data) => {
    state.connectedFacilities = data
  },
  SET_PIN_TOKEN: (state, data) => {
    state.pinToken = data
  }
}

export const actions = {
  getUserInfo ({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.auth.role_endpoint && state.auth.token) {
        const currentEpochTime = new Date().getTime()
        this.$api.get(state.auth.role_endpoint + 'me')
          .then(function (responseInfo) {
            const dataInfo = responseInfo.data.Data
            if (!dataInfo.DoctorTypeLang) {
              dataInfo.DoctorTypeLang = {
                ID: 'Dokter Umum',
                EN: 'General Practitioner'
              }
            }
            commit('SET_USER_DATA', dataInfo)
            const sentryUser = {
              email: dataInfo.Email,
              ID: dataInfo.ID,
              PublicID: dataInfo.PublicID,
              Fullname: dataInfo.Fullname,
              DoctorType: dataInfo.DoctorType,
              ClinicEmployeeType: dataInfo.ClinicEmployeeType,
              Gender: dataInfo.Gender
            }
            Sentry.setUser(sentryUser)
            // check network speed by API execution time
            const executionTime = new Date().getTime()
            const differenceTime = (executionTime - currentEpochTime) / 1000
            commit('RTC/SET_NETWORK_SPEED', differenceTime, { root: true })
            resolve(dataInfo)
          }).catch(function (error) {
            reject(error)
          })
      }
    })
  },
  getPureDocument ({ commit }, path) {
    return new Promise((resolve, reject) => {
      if (!path) {
        path = 'doctor/tnc'
      }

      this.$api.get(path)
        .then(function (responseInfo) {
          resolve(responseInfo)
        }).catch(function (error) {
          reject(error)
        })
    })
  },
  updateUserFinance ({ state }, data) {
    return new Promise((resolve, reject) => {
      const { BankID, BankName, BankNumber, BankCityID, AccountType, AccountResidence, NoNPWP, FlagNPWP, Dependents, FileNPWP, NPWPName, NPWPAddress } = data
      const formData = new FormData()
      if (BankID) { formData.append('BankID', BankID) }
      if (BankName) { formData.append('BankName', BankName) }
      if (BankNumber) { formData.append('BankNumber', BankNumber) }
      if (BankCityID) { formData.append('BankCityID', BankCityID) }
      if (AccountType) { formData.append('AccountType', AccountType) }
      if (AccountResidence) { formData.append('AccountResidence', AccountResidence) }
      if (typeof FlagNPWP !== 'undefined') { formData.append('FlagNPWP', FlagNPWP) }
      if (FlagNPWP === 1) {
        if (NoNPWP) { formData.append('NoNPWP', NoNPWP) }
        if (Dependents) { formData.append('Dependents', Dependents) }
        if (FileNPWP) { formData.append('FileNPWP', FileNPWP) }
        if (NPWPName) { formData.append('NPWPName', NPWPName) }
        if (NPWPAddress) { formData.append('NPWPAddress', NPWPAddress) }
      }

      // let object = {};
      // formData.forEach((value, key) => object[key] = value);
      // let json = JSON.stringify(object);
      // let dataJSON = JSON.parse(json)
      let url = 'doctor/document/update'
      const method = 'post'
      const resultData = formData
      if (state.auth.role === 'admin') {
        url = `admin/doctor/update/doctor/${state.auth.userData.DoctorID}/document`
        // method='put'
        // resultData = dataJSON
      }
      this.$api[method](url, resultData)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  updateProfilePicture ({ commit }, data) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('Avatar', data.Avatar)
      this.$api.post('doctor/profile/update', formData, {
        cancelToken: data.tokenAccess,
        onUploadProgress (progressEvent) {
          commit('SET_PROGRESS', parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total)))
        }
      })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  updateUserData ({ state }, data) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      if (data.Height) {
        formData.append('Height', data.Height)
      }
      if (data.Weight) {
        formData.append('Weight', data.Weight)
      }
      if (data.BloodType) {
        formData.append('BloodType', data.BloodType)
      }

      if (data.Fullname) {
        formData.append('Firstname', data.Fullname)
      }
      if (data.Email) {
        formData.append('Email', data.Email)
      }
      if (data.DoctorType) {
        formData.append('DoctorType', data.DoctorType)
      }
      if (data.Gender) {
        formData.append('Gender', data.Gender)
      }
      if (data.Birthdate) {
        formData.append('Birthdate', data.Birthdate)
      }
      if (data.University) {
        formData.append('University', data.University)
      }
      if (data.YearGraduated) {
        formData.append('YearGraduated', data.YearGraduated)
      }
      if (data.MaritalStatus) {
        formData.append('MaritalStatus', data.MaritalStatus)
      }
      if (data.WhatsappNumber) {
        formData.append('WhatsappNumber', data.WhatsappNumber)
      }
      if (data.Handphone) {
        formData.append('Handphone', data.Handphone)
      }

      if (data.AddressHome) {
        formData.append('AddressHome', data.AddressHome)
      }
      const object = {}
      formData.forEach((value, key) => {
        object[key] = value
      })
      const json = JSON.stringify(object)
      const dataJSON = JSON.parse(json)
      let url = 'doctor/profile/update'
      let method = 'post'
      let resultData = formData
      if (state.auth.role === 'admin') {
        url = `admin/doctor/update/doctor/${state.auth.userData.DoctorID}`
        method = 'put'
        resultData = dataJSON
      }
      this.$api[method](url, resultData)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  getStep ({ commit }, data) {
    const { id, token } = data

    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API + `doctor/pending/${id}/registration/status/${token}`)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  auth ({ commit }, userInfo) {
    const { email, password } = userInfo

    return new Promise((resolve, reject) => {
      const formData = {
        Email: email
      }
      commit('SET_USER_EMAIL', email)

      if (typeof password !== 'undefined' && password) {
        Object.assign(formData, {
          Password: password
        })
      }

      this.$axios.post(process.env.BASE_API + 'doctoradmin/login', formData)
        .then(function (response) {
          const res = response.data
          const data = res.Data
          if (data) {
            // res.Data.Expiration = 1656764961
            commit('SET_USER_EXPIRATION', res.Data.Expiration)
            const role = data.Role
            Sentry.setUser({
              email,
              role
            })
            if (data.Token) {
              const token = data.Token

              commit('SET_USER_TOKEN', token)
              Sentry.setUser({
                email,
                role,
                token
              })
              if (role === 'ADMIN') {
                commit('SET_USER_ROLE', 'admin')
                commit('SET_USER_ROLE_ENDPOINT', 'admin/doctor/')
              } else if (role === 'DOCTOR') {
                commit('SET_USER_ROLE', 'doctor')
                commit('SET_USER_ROLE_ENDPOINT', 'doctor/')
                commit('SET_USER_ROLE_FLAG_ENDPOINT', true)
              }

              commit('SET_USER_IS_LOGGED', true)
              resolve(res)
            } else {
              if (role === 'ADMIN') {
                commit('SET_USER_ROLE', 'admin')
                commit('SET_USER_ROLE_ENDPOINT', 'admin/doctor/')
              } else if (role === 'DOCTOR') {
                commit('SET_USER_ROLE', 'doctor')
                commit('SET_USER_ROLE_ENDPOINT', 'doctor/')
                commit('SET_USER_ROLE_FLAG_ENDPOINT', true)
              }
              resolve(res)
            }
          } else { resolve(res) }
        })
        .catch(function (error) {
          Sentry.setUser(null)
          reject(error)
        })
    })
  },
  async globalChangePassword ({ commit }, form) {
    const { id, type, password, passwordConfirmation } = form
    const saltRounds = 10
    const hash = await bcrypt.hash(password, saltRounds)
    const formData = {
      ID: id,
      Type: type,
      Password: password,
      PasswordConfirmation: passwordConfirmation
      // Hash: hash
    }
    const formDataJSON = JSON.stringify(formData)
    // const signature = Buffer.from(formDataJSON).toString('base64')
    const signature = md5(formDataJSON)
    return new Promise((resolve, reject) => {
      formData.Signature = signature
      formData.Hash = hash
      this.$axios.post(process.env.BASE_API + 'global/password/change', formData)
        .then(function (response) {
          const res = response.data
          const data = res.Data

          if (data) {
            resolve(res)
          } else { resolve(res) }
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  forgotPasswordByEmail ({ commit }, data) {
    const { email } = data

    return new Promise((resolve, reject) => {
      const formData = {
        Email: email
      }

      const url = 'doctor/forgot/password/email'

      this.$axios.post(process.env.BASE_API + url, formData)
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  forgotPasswordRegister ({ commit }, data) {
    const { email } = data

    return new Promise((resolve, reject) => {
      const formData = {
        Email: email
      }

      const url = 'doctor/pending/forgot/password'

      this.$axios.post(process.env.BASE_API + url, formData)
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  getDataAvatar () {
    return new Promise((resolve, reject) => {
      this.$api.get('doctor/avatar')
        .then(function (response) {
          const res = response.data.Data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  getConnectedClinics ({ commit, rootState }) {
    return new Promise((resolve, reject) => {
      this.$api.get(rootState.user.auth.role_endpoint + 'clinics')
        .then(function (response) {
          const res = response.data.Data
          commit('SET_CONNECTED_FACILITY', res)
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  approveClinic ({ commit }, clinicID) {
    return new Promise((resolve, reject) => {
      this.$api.post('doctor/clinic/' + clinicID + '/approve', {})
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  rejectClinic ({ commit }, clinicID) {
    return new Promise((resolve, reject) => {
      this.$api.delete('doctor/clinic/' + clinicID + '/reject')
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  unlinkClinic ({ commit }, data) {
    const { clinicID, clinicType } = data
    return new Promise((resolve, reject) => {
      this.$api.delete('doctor/clinic/' + clinicID + '/unlink/' + clinicType)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  sendEmailUpdated () {
    return new Promise((resolve, reject) => {
      this.$api.post('doctor/verify/email/send', null)
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  sendOTPUpdated ({ commit }, data) {
    const { sendUrl, sendBody } = data

    return new Promise((resolve, reject) => {
      this.$api.post(sendUrl, sendBody)
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  sendOTP ({ commit }, data) {
    const { sendUrl, sendBody } = data

    return new Promise((resolve, reject) => {
      this.$axios.post(process.env.BASE_API + sendUrl, sendBody)
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  updateSK ({ commit }, data) {
    const { id } = data

    return new Promise((resolve, reject) => {
      if (id) {
        this.$api.get(`doctor/document/tnc/${id}`)
          .then(function (response) {
            const res = response.data
            resolve(res)
          })
          .catch(function (error) {
            reject(error)
          })
      }
    })
  },

  updateSKAdmin () {
    return new Promise((resolve, reject) => {
      this.$api.post('admin/doctor/tnc/accept', null)
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  updateSKRegister ({ commit }, data) {
    const { id } = data

    return new Promise((resolve, reject) => {
      if (id) {
        this.$axios.get(process.env.BASE_API + `doctor/pending/${id}/document-tnc`)
          .then(function (response) {
            const res = response.data
            resolve(res)
          })
          .catch(function (error) {
            reject(error)
          })
      }
    })
  },

  verifyOTP ({ commit }, data) {
    const { verifyUrl, verifyBody } = data

    return new Promise((resolve, reject) => {
      this.$axios.post(process.env.BASE_API + verifyUrl, verifyBody)
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  register ({ commit }, data) {
    const { body } = data

    return new Promise((resolve, reject) => {
      this.$axios.post(process.env.BASE_API + 'doctor/register', body)
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  checkOtpStatus ({ commit }, data) {
    const { id } = data

    return new Promise((resolve, reject) => {
      this.$axios.post(process.env.BASE_API + `doctor/pending/${id}/check/otp/banned`, {})
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  forgotChangePassword ({ commit }, data) {
    const { type, token, password, password_confirm, partOf } = data

    return new Promise((resolve, reject) => {
      const formData = {
        Password: password,
        Password_confirmation: password_confirm
      }

      let url = 'doctor/change/password'

      if (type === 'otp') { url = 'doctor/change/password/otp' }

      if (partOf === 'reg') { url = 'doctor/pending/change/password' }

      url += '/' + token

      this.$axios.post(process.env.BASE_API + url, formData)
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  sendEmailRegister ({ commit }, data) {
    const { registerId, email } = data

    return new Promise((resolve, reject) => {
      this.$axios.post(process.env.BASE_API + 'doctor/pending/' + registerId + '/send/email', {
        Email: email
      })
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  logout ({ dispatch }) {
    return new Promise((resolve, reject) => {
      this.$api.post('doctor/logout', {})
        .then(function (response) {
          resolve()
          dispatch('resetDataUser')
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  resetDataUser ({ commit }) {
    // eslint-disable-next-line
    $nuxt.$emit('stopCheckingSchedule')
    // eslint-disable-next-line
    $nuxt.$emit('stopCheckingScheduleOtherPage')
    commit('SET_USER_TOKEN', null)
    commit('SET_USER_EMAIL', null)
    commit('SET_USER_EXPIRATION', null)
    commit('SET_USER_DATA', null)
    commit('SET_USER_IS_LOGGED', false)
    Sentry.setUser(null)
    if (localStorage.getItem('modalTelegram')) {
      localStorage.removeItem('modalTelegram')
    }
  },

  resetUserEmailExpiration ({ commit }) {
    commit('SET_USER_EMAIL', null)
    commit('SET_USER_EXPIRATION', null)
  },

  // profile
  getListStaffAdmin ({ commit }, data) {
    const { publicid } = data

    if (publicid) {
      return new Promise((resolve, reject) => {
        this.$api.get('doctor/' + publicid + '/admins')
          .then(function (response) {
            const res = response.data
            resolve(res)
          })
          .catch(function (error) {
            reject(error)
          })
      })
    }
  },

  saveStaffAdmin ({ commit }, data) {
    return new Promise((resolve, reject) => {
      const self = this
      self.$api.post('doctor/add/admin', data)
        .then(function (response) {
          const res = response.data.Data

          if (res.ID) {
            self.$api.post('doctor/send/admin/' + res.ID + '/verify', data)
              .then(function (response2) {
                const res2 = response2.data.Data
                resolve(res2)
              })
              .catch(function (error) {
                reject(error)
              })
          }
        })
        .catch(function (error) {
          const err = error.response
          reject(err)
        })
    })
  },

  updateStaffAdmin ({ commit }, data) {
    const { Name, Email, Password, Password_confirmation, ID } = data
    return new Promise((resolve, reject) => {
      const self = this
      self.$api.post('doctor/admin/' + ID + '/update', {
        Name,
        Email,
        Password,
        Password_confirmation
      })
        .then(function (response) {
          const res = response.data.Data

          if (res.ID) {
            self.$api.post('doctor/send/admin/' + res.ID + '/verify', data)
              .then(function (response2) {
                const res2 = response2.data.Data
                resolve(res2)
              })
              .catch(function (error) {
                reject(error)
              })
          }
        })
        .catch(function (error) {
          const err = error.response
          reject(err)
        })
    })
  },

  deleteStaffAdmin ({ commit }, id) {
    return new Promise((resolve, reject) => {
      this.$api.post('doctor/admin/' + id + '/delete', {})
        .then(function (response) {
          const res = response.data.Data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  changePassword ({ commit }, data) {
    const { old_password, password, confirm_password } = data

    return new Promise((resolve, reject) => {
      const formData = {
        OldPassword: old_password,
        Password: password,
        Password_confirmation: confirm_password
      }

      const url = 'doctor/change/password'

      this.$api.post(url, formData)
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  createPIN ({ rootState }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios.post(process.env.BASE_API_V4 + 'doctor/pin', payload, {
        headers: {
          DeviceType: 'web',
          Authorization: 'Bearer ' + rootState.user.auth.token
        }
      })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          const err = error.response
          reject(err)
        })
    })
  },

  inputPIN ({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios.post(process.env.BASE_API_V4 + 'doctor/pin/verify', payload, {
        headers: {
          DeviceType: 'web',
          Authorization: 'Bearer ' + rootState.user.auth.token
        }
      })
        .then(function (response) {
          commit('SET_PIN_TOKEN', response.data.Data.Token)
          resolve(response)
        })
        .catch(function (error) {
          const err = error.response
          reject(err)
        })
    })
  },

  changePIN ({ rootState }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios.post(process.env.BASE_API_V4 + 'doctor/pin/change', payload, {
        headers: {
          DeviceType: 'web',
          Authorization: 'Bearer ' + rootState.user.auth.token
        }
      })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          const err = error.response
          reject(err)
        })
    })
  }
}
